// imports react
import React, { useState, useEffect, useRef } from 'react';

//imports libraries
import { ArrowUp, Lightbulb, BrainCircuit, Square, MenuIcon, History, GraduationCap, SquareActivity, ClipboardPenLine, LoaderIcon, Loader2Icon } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom'
import ReactMarkdown from 'react-markdown';

//imports components
import styles from '../styles/evokchat.module.css';

import { urlAPI_Current } from '../config';
import { logoutUser } from "../logoutUser";
import { userLogged } from '../userLogged';
import { verifyUserPaid } from '../verifyUserPaid';
import { Menu } from '../components/Menu';
import { ContainerSuggestions } from '../components/ContainerSuggestions';
import useAccessTracking from '../components/useAccessTracking';
import { verifyAuthToken } from '../verifyAuthToken';
const { v4: uuidv4 } = require('uuid');

export function EvokChat() {
    const [userData, setUserData] = useState([]);
    const [planActually, setPlanActually] = useState([]);
    const [interactions, setInteractions] = useState([]);
    const [message, setMessage] = useState('');
    const [messagesHistory, setMessagesHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [hasInteraction, setHasInteraction] = useState(false);
    const [relatorioEnviado, setRelatorioEnviado] = useState(false);

    const messagesEndRef = useRef(null);
    const [autoScroll, setAutoScroll] = useState(true);

    const [searchParams] = useSearchParams();
    let success = searchParams.get('success');

    const navigateTo = useNavigate()

    const [darkMode, setDarkMode] = useState(() => 
        window.localStorage.getItem('darkMode') === 'true'
    );

    useAccessTracking();

    const suggestions = ["Qual o meu nível de criatividade e como posso melhora-lo?", "Como posso melhorar a minha comunicação?", "Como posso ter acesso a novas oportunidades?"];

    async function getUserLogged(){
        const user = await userLogged();
        setUserData(user)

        if (!user) { // não tiver usuário, ou authToken invalido
          toast.error('Faça o login primeiro');
          navigateTo('/login');
        } 
        else if(user.codTipoUsuario != 1){
          logoutUser();
          toast.error('Você não tem acesso a essa página');
          navigateTo('/login');
        } else { // loga
            const responsePaid = await verifyUserPaid();
            if(responsePaid.success == true){
                console.log(`Plano Atual ${responsePaid.plan}`);
                setPlanActually(responsePaid.plan); 

                await getAllUserMessages();
                await verifyReportIsSent();
                await getSkills();
            } else {
                toast.error('Faça o pagamento primeiro');
                navigateTo("/plans");
            }
        }
    }

    async function getSkills(){
        try {
            const responseSkills = await axios.post(`${urlAPI_Current}/getSkills`, {} , {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                }
            });
            if(responseSkills.data.success == true) {
                const skillsResponse = responseSkills.data.userSkills;

                console.log("Usuário possui skills");
                fetchInteractions();
            } else {
                console.log("Usuário não possui skills");
            }
        } catch (error) {
            console.log("Erro ao buscar skills")
        }
    }

    async function fetchInteractions() {
        /*
        try {
            const response = await axios.post(`${urlAPI_Current}/getInteractions`, {} , {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                }
            });
            
            const fetchedInteractions = [];

            for (const key in response.data.messages) {
                fetchedInteractions.push({
                    message: response.data.messages[key].mensagem,
                    result: cleanText(response.data.messages[key].resultado)
                });
            }


            if(fetchedInteractions.length > 0){
                setInteractions([...fetchedInteractions]);
                setHasInteraction(true);
            }else {
                setHasInteraction(false);
            }
            console.log(hasInteraction);
        } catch (error) {
            console.error('Erro ao buscar interações:', error);
        } */
    }

    async function verifyReportIsSent(){
        try {
            const responseProfile = await axios.post(
              `${urlAPI_Current}/getProfile`, {}, {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                }
                }
            );
      
            if(responseProfile.data.user.relatorioEnviado == 1) {
                setRelatorioEnviado(true);
                return true;
            } else {
                setRelatorioEnviado(false);
            }
            const has1Hability = responseProfile.data.user.inteligencia_emocional;
            const has2Hability = responseProfile.data.user.complexidade;

            if(responseProfile.data.success == true) {
                if(has1Hability && has2Hability == null) {
                    toast.error('Você não terminou o questionário');
                    navigateTo('/questionary');
                    return false;
                } else if(has1Hability == null){
                    toast.error('Você não respondeu o questionário');
                    navigateTo('/questionaryAlert');
                    return false;
                }
            } else {
                console.log("Não respondeu")
                return false;
            }  
        } catch (error) {
            console.log("Erro ao buscar respondidas")
            return false;
        }
    }

    async function handleSendMessage(suggestion) {
        /*
        const messageToSend = suggestion || message;
    
        try {
            if (messageToSend.length < 3 || !relatorioEnviado) {
                toast.error('Escreva alguma mensagem maior');
                return;
            } else {
                if (planActually != 2 && planActually != 3 && planActually != 4) { // O plano gratuito vai ler limite de perguntas
                    const responseLimit = await axios.post(`${urlAPI_Current}/verifyLimitPlanLite`, {} , {
                        headers: {
                          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                        }
                    });
    
                    if (responseLimit.data.blocked) {
                        toast.error(`Você atingiu o limite de perguntas para o plano gratuito. Tempo restante: ${responseLimit.data.unlocksIn}`);
                        return;
                    }
                }
    
                setIsLoading(true);
                setHasInteraction(true);
    
                setMessage('');
    
                let newInteraction = {
                    id: uuidv4(),
                    message: messageToSend,
                    result: "Carregando..."
                };
    
                setInteractions(prevInteractions => [...prevInteractions, newInteraction]);
    
                const handleStream = async () => {
                    const response = await fetch(`${urlAPI_Current}/sendMessageChat`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            message: messageToSend,
                            threadId: localStorage.getItem('idThread'),
                            planActually: planActually
                        }, {
                            headers: {
                              'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                            }
                        }),
                    });
    
                    const reader = response.body.getReader();
                    const decoder = new TextDecoder();
                    const loopRunner = true;

                    while (loopRunner) {
                        const { value, done } = await reader.read();
                        if (done) {
                            setIsLoading(false);
                          break;
                        }
                        const decodedChunk = decoder.decode(value, { stream: true });
                        setInteractions(prevInteractions =>
                            prevInteractions.map(interaction => 
                                interaction.id === newInteraction.id
                                    ? { 
                                        ...interaction, 
                                        result: interaction.result === "Carregando..." 
                                            ? cleanText(decodedChunk) 
                                            : cleanText(interaction.result + decodedChunk) 
                                    }
                                    : interaction
                            )
                        );
                      }
                }
    
                handleStream();
            }
        } catch (err) {
            console.log(err);
            toast.error('Erro ao enviar a mensagem');
        } */
    }
    
    const handleSuggestionClick = (suggestion) => {
        console.log("Sugestão selecionada:", suggestion);
        setMessage(suggestion);
        handleSendMessage(suggestion);
    };

    async function getAllUserMessages() {
        /*
        try {
          const response = await axios.post(
            `${urlAPI_Current}/getAllUserMessages`,{} , {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
                }
            }
          );
          if (response.data.success == true) {
            const responseMesssages = response.data.messages;
            if (responseMesssages) {
              setMessagesHistory(responseMesssages);
              console.log(responseMesssages);
            }
          } else {
            console.log("Não possue historico mensagens");
          }
        } catch (error) {
          console.log("Erro ao buscar historico mensagens");
        } */
    }

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage();
        }
    };

    useEffect(() => {
        navigateTo('/resultQuestionary');
        getUserLogged();

        window.localStorage.setItem('darkMode', darkMode);
        document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    }, [relatorioEnviado, darkMode]);

    // Verifica se o usuário esta scrollando, se tiver, ele não da scroll automatico até a mensagem
    useEffect(() => {
        const handleScroll = () => {
            if (messagesEndRef.current) {
                const isUserScrollingUp =
                    messagesEndRef.current.scrollTop < messagesEndRef.current.scrollHeight - messagesEndRef.current.clientHeight;
                setAutoScroll(!isUserScrollingUp);
            }
        };

        if (messagesEndRef.current) {
            messagesEndRef.current.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (messagesEndRef.current) {
                messagesEndRef.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    // Ajusta o scroll da div para o final sempre que uma nova mensagem é adicionada
    useEffect(() => {
        if (autoScroll && messagesEndRef.current) {
            messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
        }
    }, [interactions, autoScroll]);

    async function onClickSuggestion(body){
        console.log("Sugestão selecionada:", body);
        setMessage(body);
        handleSendMessage(body);
    }

    const cleanText = (text) => {
        // Remove citações 
        return text.replace(/【\d+:\d+†source】/g, '');
    };

    useEffect(() => {
        verifyAuthToken(navigateTo);
    }, []);

  return (
    <div className={styles.evokChat}>
        <Menu darkMode={darkMode}/>
        <div className={styles.containersChat}>
                <button
                    className={styles.togglebutton}
                    onClick={toggleVisibility}
                >
                    <MenuIcon />
                </button>
                <div className={`${styles.containerLeft} ${isVisible ? styles.show : ''}`}>
                    <p><Lightbulb style={{ color: '#7d7d7d' }} /><strong>Sugestões de prompt</strong></p>
                    <p className={styles.suggestions}>Clique em um prompt para selecioná-lo:</p>
                    {suggestions.map((suggestion, index) => (
                        <p
                            key={index}
                            className={styles.suggestions}
                            onClick={() => handleSuggestionClick(suggestion)}
                        >
                            {index + 1}. {suggestion}
                        </p>
                    ))}
                    <p><History style={{ color: '#7d7d7d' }} /><strong>Ultimas perguntas</strong></p>
                    {messagesHistory.map((message, index) => (
                        <p
                            key={index}
                            className={styles.suggestions}
                        >
                            {message.mensagem}
                        </p>
                    ))}
            </div>
            {isVisible && <div className={styles.overlay} onClick={toggleVisibility}></div>}
            <div className={styles.chat_container}>
                <div className={styles.chat_box_header}>
                    <div className={styles.headerName}>
                    <h4><strong>
                    {planActually === 1
                    ? "EvokLite"
                    : planActually === 2
                    ? "EvokPersona"
                    : planActually === 3
                    ? "EvokTeam"
                    : "EvokLite"}
                    </strong></h4>     
                    </div>
                </div>
                {
                    hasInteraction ? (
                        <div ref={messagesEndRef} className={styles.chat_box}>
                        {relatorioEnviado ? (
                            interactions.map((interaction, index) => (
                            <div key={index} className={styles.interactions}>
                                <div>
                                    <div className={styles.containerMessage_received}>
                                    <div className={styles.message_received}>{interaction.message}</div>
                                    </div>
                                    <div className={styles.message_sent}>
                                        <div className={styles.containerIconSent}>
                                            {darkMode ? (
                                                <svg width="26" height="26" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
                                                <g transform="translate(0,500) scale(0.1,-0.1)" fill="#FFFFFF" stroke="none">
                                                    <path d="M551 4323 c35 -59 88 -150 141 -243 l48 -85 -205 -3 c-123 -1 -205 -6 -205 -12 0 -5 39 -76 87 -157 186 -318 515 -879 558 -953 18 -30 86 -147 152 -260 132 -226 408 -696 758 -1295 126 -214 249 -426 275 -470 25 -44 68 -117 94 -163 27 -46 52 -82 57 -80 5 2 53 79 107 173 55 93 103 170 108 172 6 2 49 -78 98 -178 72 -148 90 -179 100 -168 13 14 41 62 381 654 95 165 224 390 287 500 63 110 168 292 233 405 64 113 141 246 170 295 29 50 164 284 300 520 248 432 273 475 469 813 58 100 106 187 106 192 0 6 -85 11 -204 12 l-204 3 124 175 c67 96 123 178 123 183 1 4 -895 7 -1990 7 l-1991 0 23 -37z m2466 -81 c688 -4 1254 -10 1258 -14 4 -4 -30 -61 -75 -127 l-82 -121 -1473 -2 -1473 -3 118 -190 c64 -104 178 -289 252 -410 340 -552 434 -706 484 -785 29 -47 102 -166 162 -265 60 -98 114 -181 119 -182 6 -2 71 103 146 234 74 131 188 330 253 443 64 113 129 226 143 253 l26 47 153 0 153 0 -25 -42 c-13 -24 -164 -288 -334 -588 -170 -300 -342 -601 -381 -669 -39 -68 -71 -125 -71 -127 0 -10 -63 -104 -70 -104 -4 0 -48 69 -98 153 -49 83 -133 226 -187 317 -147 248 -813 1373 -965 1630 -73 124 -175 296 -226 383 -52 87 -94 162 -94 167 0 11 410 11 2287 2z m-2192 -384 c16 -23 185 -306 420 -703 123 -210 334 -566 515 -870 59 -99 158 -268 222 -375 343 -580 319 -543 332 -523 7 10 89 153 183 318 398 701 710 1249 784 1376 43 75 79 139 79 142 0 4 -269 7 -598 7 l-598 0 -77 123 -77 122 42 7 c24 3 234 7 468 8 234 2 632 5 885 9 253 3 463 4 467 1 3 -3 -82 -156 -189 -340 -107 -184 -206 -353 -218 -375 -13 -22 -110 -189 -215 -370 -106 -182 -201 -346 -212 -365 -11 -19 -44 -75 -73 -125 -29 -49 -117 -200 -195 -335 -79 -135 -168 -288 -199 -341 -31 -52 -101 -173 -156 -267 -55 -95 -102 -172 -105 -172 -5 0 -47 70 -160 265 -26 44 -165 283 -310 530 -145 248 -284 486 -310 530 -26 44 -71 121 -100 170 -29 50 -83 142 -120 205 -37 63 -147 252 -245 420 -98 168 -193 330 -210 360 -18 30 -100 172 -184 314 -83 143 -151 263 -151 268 0 4 65 8 145 8 138 0 145 -1 160 -22z m3655 10 c0 -7 -10 -29 -22 -48 -32 -54 -215 -370 -303 -525 -13 -22 -74 -128 -135 -235 -62 -107 -156 -269 -208 -360 -52 -91 -136 -237 -187 -325 -51 -88 -180 -313 -287 -500 -391 -681 -583 -1013 -599 -1036 -16 -24 -17 -23 -82 107 l-65 130 52 90 c29 49 216 370 416 714 339 583 909 1560 978 1677 17 28 29 53 27 55 -3 2 -1378 -13 -2066 -24 l-187 -3 154 -240 c84 -132 182 -287 219 -345 36 -58 110 -175 165 -260 l99 -155 -36 -65 c-43 -79 -104 -180 -107 -180 -4 0 -59 90 -366 590 -59 96 -210 342 -335 545 -125 204 -230 378 -233 388 -4 16 75 17 1552 17 1238 0 1556 -3 1556 -12z m-1732 -756 c-18 -47 -234 -412 -242 -409 -9 3 -266 401 -266 412 0 3 115 5 256 5 141 0 254 -4 252 -8z"/>
                                                </g>
                                                </svg>
                                                
                                                ) : (
                                                <svg width="26" height="26" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
                                                <g transform="translate(0,500) scale(0.1,-0.1)" fill="#000" stroke="none">
                                                    <path d="M551 4323 c35 -59 88 -150 141 -243 l48 -85 -205 -3 c-123 -1 -205 -6 -205 -12 0 -5 39 -76 87 -157 186 -318 515 -879 558 -953 18 -30 86 -147 152 -260 132 -226 408 -696 758 -1295 126 -214 249 -426 275 -470 25 -44 68 -117 94 -163 27 -46 52 -82 57 -80 5 2 53 79 107 173 55 93 103 170 108 172 6 2 49 -78 98 -178 72 -148 90 -179 100 -168 13 14 41 62 381 654 95 165 224 390 287 500 63 110 168 292 233 405 64 113 141 246 170 295 29 50 164 284 300 520 248 432 273 475 469 813 58 100 106 187 106 192 0 6 -85 11 -204 12 l-204 3 124 175 c67 96 123 178 123 183 1 4 -895 7 -1990 7 l-1991 0 23 -37z m2466 -81 c688 -4 1254 -10 1258 -14 4 -4 -30 -61 -75 -127 l-82 -121 -1473 -2 -1473 -3 118 -190 c64 -104 178 -289 252 -410 340 -552 434 -706 484 -785 29 -47 102 -166 162 -265 60 -98 114 -181 119 -182 6 -2 71 103 146 234 74 131 188 330 253 443 64 113 129 226 143 253 l26 47 153 0 153 0 -25 -42 c-13 -24 -164 -288 -334 -588 -170 -300 -342 -601 -381 -669 -39 -68 -71 -125 -71 -127 0 -10 -63 -104 -70 -104 -4 0 -48 69 -98 153 -49 83 -133 226 -187 317 -147 248 -813 1373 -965 1630 -73 124 -175 296 -226 383 -52 87 -94 162 -94 167 0 11 410 11 2287 2z m-2192 -384 c16 -23 185 -306 420 -703 123 -210 334 -566 515 -870 59 -99 158 -268 222 -375 343 -580 319 -543 332 -523 7 10 89 153 183 318 398 701 710 1249 784 1376 43 75 79 139 79 142 0 4 -269 7 -598 7 l-598 0 -77 123 -77 122 42 7 c24 3 234 7 468 8 234 2 632 5 885 9 253 3 463 4 467 1 3 -3 -82 -156 -189 -340 -107 -184 -206 -353 -218 -375 -13 -22 -110 -189 -215 -370 -106 -182 -201 -346 -212 -365 -11 -19 -44 -75 -73 -125 -29 -49 -117 -200 -195 -335 -79 -135 -168 -288 -199 -341 -31 -52 -101 -173 -156 -267 -55 -95 -102 -172 -105 -172 -5 0 -47 70 -160 265 -26 44 -165 283 -310 530 -145 248 -284 486 -310 530 -26 44 -71 121 -100 170 -29 50 -83 142 -120 205 -37 63 -147 252 -245 420 -98 168 -193 330 -210 360 -18 30 -100 172 -184 314 -83 143 -151 263 -151 268 0 4 65 8 145 8 138 0 145 -1 160 -22z m3655 10 c0 -7 -10 -29 -22 -48 -32 -54 -215 -370 -303 -525 -13 -22 -74 -128 -135 -235 -62 -107 -156 -269 -208 -360 -52 -91 -136 -237 -187 -325 -51 -88 -180 -313 -287 -500 -391 -681 -583 -1013 -599 -1036 -16 -24 -17 -23 -82 107 l-65 130 52 90 c29 49 216 370 416 714 339 583 909 1560 978 1677 17 28 29 53 27 55 -3 2 -1378 -13 -2066 -24 l-187 -3 154 -240 c84 -132 182 -287 219 -345 36 -58 110 -175 165 -260 l99 -155 -36 -65 c-43 -79 -104 -180 -107 -180 -4 0 -59 90 -366 590 -59 96 -210 342 -335 545 -125 204 -230 378 -233 388 -4 16 75 17 1552 17 1238 0 1556 -3 1556 -12z m-1732 -756 c-18 -47 -234 -412 -242 -409 -9 3 -266 401 -266 412 0 3 115 5 256 5 141 0 254 -4 252 -8z"/>
                                                </g>
                                            </svg>
                                            )}
                                        </div>
                                        <ReactMarkdown 
                                            className={styles.chatText} 
                                            children={interaction.result}
                                        />
                                    </div>
                                </div>
                            </div>
                            ))
                        ) : (
                            <div className={styles.evokChatLoading}>
                                <div className={styles.evokChatLoadingText}>
                                    <p>Carregando <Loader2Icon/></p>
                                    <p>Estamos personalizando a IA com suas informações e ajustando tudo para oferecer a melhor experiência possível. Em breve, você estará pronto para começar!</p>
                                </div>
                            </div>
                        )}
                    </div>
                    ) : (
                        <div className={styles.howHelp}>
                            <p>Como posso ajudar?</p>
                        </div>
                    )
                }
               
               {hasInteraction ? (
                    <div className={styles.input_container}>
                        <input 
                                type="text" 
                                id="user-input" 
                                placeholder="Faça uma pergunta" 
                                value={message} 
                                onChange={(e) => setMessage(e.target.value)}
                                onKeyPress={handleKeyPress}  
                        />
                        {isLoading || interactions.length < 1 ? 
                            <button className={styles.send_button_d} disabled><Square className={styles.square_color}/></button>
                        :
                            <button 
                                className={`${styles.send_button} ${relatorioEnviado && message.length > 2 ? styles.send_button_active : ''}`} 
                                onClick={() => handleSendMessage()}
                            >
                                <ArrowUp />
                            </button>
                        }
                    </div>
                ) : (
                    <div className={styles.containerNoInteraction}>
                        <div className={styles.input_container_noInteraction}>
                            <input 
                                    type="text" 
                                    id="user-input" 
                                    placeholder="Faça uma pergunta" 
                                    value={message} 
                                    onChange={(e) => setMessage(e.target.value)}
                                    onKeyPress={handleKeyPress}  
                            />
                            {isLoading ? 
                                <button className={styles.send_button_d} disabled><Square className={styles.square_color}/></button>
                            :
                                <button 
                                    className={`${styles.send_button} ${relatorioEnviado && message.length > 2 ? styles.send_button_active : ''}`} 
                                    onClick={() => handleSendMessage()}
                                >
                                    <ArrowUp />
                                </button>
                            }
                        </div>
                        <div className={styles.divContainerSuggestions}>
                            <ContainerSuggestions handleClickSuggestion={onClickSuggestion} header={<GraduationCap />} colorIcon="#4287f5" title="Propósitos" body="Como posso alinhar meus propósitos aos meus objetivos?" />
                            <ContainerSuggestions handleClickSuggestion={onClickSuggestion} header={<Lightbulb />} colorIcon="#f5ec42" title="Habilidades " body="Quais habilidades essênciais preciso desenvolver? " />
                            <ContainerSuggestions handleClickSuggestion={onClickSuggestion} header={<SquareActivity />} colorIcon="#f54242" title="Motiveção" body="O que realmente me motiva?" />
                            <ContainerSuggestions handleClickSuggestion={onClickSuggestion} header={<ClipboardPenLine />} colorIcon="#da42f5" title="Experiências" body="Como minhas experiências moldam quem eu sou hoje?" />
                        </div>
                    </div>
                )
               }
                <div className={styles.warning}>
                    <p>O Evok™ Pode cometer erros, considere avaliar informações importantes.</p>
                </div>
            </div>
        </div>
    </div>
  );
}
